import { CircularProgress, Icon } from '@mui/material';
import MyGridView from 'components/GridView';
import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MyFunctions from 'functions/myFunctions';
import withAuth from 'functions/withAuth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import paymentMethodService from 'services/paymentMethodService';

const PaymentMethodsList = () => {
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    let navigate = useNavigate();

    function getAll() {
        paymentMethodService.getAll().then(res => {
            setData([...res]);
            setIsDataLoaded(true);
        });
    }

    useEffect(() => {
        getAll();
    }, []);

    if (!isDataLoaded) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <CircularProgress color="success" size={60} />
                <p style={{ color: 'green' }}>الرجاء الإنتظار</p>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="_container">
                <MyGridView
                    source={data}
                    columns={[
                        {
                            "field": "name",
                            "headerText": "طريقة الدفع",
                            "width": 70,
                            "textAlign": "right"
                        },
                        {
                            "field": "walletNumber",
                            "headerText": "رقم المحفظة",
                            "width": 90,
                            "textAlign": "right",
                        },
                    ]}
                    allowFiltering={true}
                    actionButtons={[
                        {
                            "content": <Icon color='info'>edit</Icon>,
                            "action": (id) => {
                                return navigate("/paymentMethods/" + id)
                            }
                        },
                        {
                            "content": <Icon color='error'>delete</Icon>,
                            "action": (id) => {
                                MyFunctions.showConfirmationMessage("عملية حذف", "هل أنت متأكد من الحذف!", () => {
                                    paymentMethodService.delete(id).then(res => {
                                        getAll();
                                    });
                                })
                            }
                        },
                    ]}
                    addAction={() => {
                        return navigate("/paymentMethods/" + 0)
                    }}
                />
            </div>
            <Footer />
        </DashboardLayout>
    );
}

export default withAuth(PaymentMethodsList);
